__webpack_require__.p = "/GeoNews/";